import { render, staticRenderFns } from "./RegularHeader.vue?vue&type=template&id=19ade2d8&scoped=true"
import script from "./RegularHeader.vue?vue&type=script&lang=js"
export * from "./RegularHeader.vue?vue&type=script&lang=js"
import style0 from "./RegularHeader.vue?vue&type=style&index=0&id=19ade2d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ade2d8",
  null
  
)

export default component.exports